import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './nodeRender.module.less';
import { Tooltip } from 'antd';

interface NodeRenderProps {
  handleNodeClick: any;
  data: any;
  currentSelectNode: any;
}

const NodeRender: ForwardRefExoticComponent<PropsWithoutRef<NodeRenderProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    handleNodeClick,
    currentSelectNode,
    data,
  },
  ref,
) => {
  const renderNode = () => {
    const selected = currentSelectNode?.id === data?.id;
    return (
      <div
        className={`${styles.custom_box} ${selected ? styles.custom_box_selected : ''}`}
        style={data.isProduct ? { cursor: 'pointer' } : {}}
      >
        <div
          className={styles.left_line}
        //   style={data.disabled ? { background: '#ADADAD' } : {}}
        />
        <div
          className={styles.label_box}
          style={{ padding: '10px 8px' }}
        //   style={data.disabled ? { color: '#666666' } : { cursor: 'pointer' }}
          onClick={() => {
            if (data.isProduct) {
              handleNodeClick(data, selected);
            }
          }}
        >
          {data.label}
        </div>
      </div>
    );
  };

  const renderMaterial = () => {
    const selected = currentSelectNode?.id === data?.id;
    return (
      <div
        className={`${styles.custom_box} ${selected ? styles.custom_box_selected : ''} ${data.isHighlight ? styles.custom_box_active : ''}`}
        style={{ minHeight: '50px', lineHeight: '24px', cursor: 'pointer' }}
      >
        <div
          className={styles.left_line}
        //   style={data.disabled ? { background: '#ADADAD' } : {}}
        />
        <div
          className={styles.label_box}
          style={{ marginLeft: '0' }}
        //   style={data.disabled ? { color: '#666666', marginLeft: '0' } : { cursor: 'pointer', marginLeft: '0' }}
          onClick={() => {
            handleNodeClick(data, selected);
          }}
        >
          <Tooltip title={data.label} >
            <div style={{ borderBottom: '2px solid #8EBEED', padding: '0 4px' }} className={styles.label_box_text}>
              {data.label}
            </div>
          </Tooltip>
          <div style={{ padding: '0 4px' }} className={styles.label_box_text}>{data.id}</div>
        </div>
      </div>
    );
  };

  return data?.isMaterial ? (
    renderMaterial()
  ) : (
    renderNode()
  );
});
export default NodeRender;
